var _style, _path, _rect, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPay(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:url(#SVGID_2_);}\n\t.st2{fill:url(#SVGID_3_);}\n\t.st3{fill:url(#SVGID_4_);}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 77.0206,
    y1: 256,
    x2: 434.8793,
    y2: 256
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2B95DC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8844F8"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M395.5,15.5h-148c-21.3,0-39.4,18-39.4,39.4v152.5c-5.3,3.3-10.6,7.3-16.6,12.7c-22,20.6-38,48.8-45.1,79.5 c-11.6,51.2-36,72.3-36.2,72.5c-0.4,0.4-0.7,0.9-1.1,1.3l-0.2-0.2l-29.9,29.9c-2.8,2.8-2.8,7.5,0,10.3l80.9,80.9 c1.4,1.4,3.3,2.1,5.2,2.1s3.7-0.7,5.2-2.1l29.9-29.9l-0.1-0.1c0,0,0,0,0.1,0l77.3-59c0.9-0.7,1.6-1.5,2-2.4l9.6-18.7h106.3 c21.3,0,39.4-18,39.4-39.4V54.8C434.9,33.1,417.2,15.5,395.5,15.5z M165.2,478.9l-70.6-70.6l20.3-20.3l70.6,70.6L165.2,478.9z  M278.3,373.6l-10.9,21.1l-70.9,54.2l-71.3-71.3c8.9-9.9,26-33.4,35.4-74.9c6.4-27.9,21-53.5,40.7-72c2.4-2.1,4.6-4,6.8-5.7v111 c0,2.3,1,4.4,2.8,5.8c1.8,1.4,4.1,1.9,6.3,1.3c14.2-3.7,40-13.2,53.2-34.6l18.2-29.8c5.2-8.3,16-10.8,24.2-5.7 c7.2,4.6,8.3,11.4,8.3,15c0,3.4-0.5,5.7-2.1,8.3L278.3,373.6z M420.3,344.9c0,13.4-11.4,24.8-24.8,24.8h-98.7l35-66.2 c2.7-4.6,4-9.3,4-15.4c0-11.3-5.5-21.2-15.1-27.3c-7.3-4.6-15.9-6-24.3-4c-8.3,2-15.4,7.1-20,14.4L258.1,301 c-8.2,13.3-23.3,21-35.3,25.3V54.8c0-13.4,11.3-24.8,24.8-24.8h148c13.4,0,24.8,11.3,24.8,24.8V344.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 294.9416,
    y1: 51.9262,
    x2: 347.4191,
    y2: 51.9262
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2B95DC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8844F8"
    }
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 294.9,
    y: 44.6,
    className: "st1",
    width: 52.5,
    height: 14.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 299.3188,
    y1: 160.8867,
    x2: 343.049,
    y2: 160.8867
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2B95DC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8844F8"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M321.2,140.1c3.3,0,7.3,4,7.3,7.3H343c0-8.7-6.4-17-14.6-20.3v-11h-14.6v11c-8.1,3.3-14.6,11.6-14.6,20.3 c0,11.2,10.6,21.9,21.9,21.9c3.5,0,7.3,2.8,7.3,7.3c0,3.3-4,7.3-7.3,7.3c-3.5,0-7.3-2.8-7.3-7.3h-14.6c0,9.5,6.1,17.5,14.6,20.5 v8.6h14.6v-8.8c8.1-3.3,14.6-11.6,14.6-20.3c0-12.1-9.8-21.9-21.9-21.9c-3.3,0-7.3-4-7.3-7.3C313.9,144.1,317.9,140.1,321.2,140.1z "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 251.2115,
    y1: 161.2514,
    x2: 391.1492,
    y2: 161.2514
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2B95DC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8844F8"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M321.2,91.3c-38.6,0-70,31.4-70,70s31.4,70,70,70c38.6,0,70-31.4,70-70S359.8,91.3,321.2,91.3z M321.2,216.6 c-30.5,0-55.4-24.8-55.4-55.4s24.8-55.4,55.4-55.4c30.5,0,55.4,24.8,55.4,55.4S351.7,216.6,321.2,216.6z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPay);
export default __webpack_public_path__ + "static/media/pay.8bd94710890d52aaa27598f70a19d5d4.svg";
export { ForwardRef as ReactComponent };